import React, {useEffect, useState, useRef} from "react";
import {createUseStyles, useTheme} from "react-jss";
import FormCompontent from "../../../../../../../../../../artibulles-cis/FormComponent/FormCompontent";
import CheckBox from "../../../../../../../../../../artibulles-cis/CheckBox/CheckBox";

import TabNavContent from "@artibulles-cis/react/TabNavContent";
//eslint-disable-next-line
const styles = createUseStyles((theme) => ({
    ClassExtendTabContent: {
        padding: "10px 5px 10px 5px",
        boxSizing: "border-box",
        // maxWidth: "1200px",
    },
    FormMultilineFlex: {
        display: "flex",
        flexDirection: "row",
        margin: "2px 0px",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "space-between",
    },
    FormFieldMultiLineMaxWidth: {
        flex: "0 1 300px",
        margin: "0px 0px 0px 0px",
    },
    FormFieldMultiLineLeft: {
        flex: "0 1 300px",
    },
    FormFieldGroup: {
        margin: "2px 5px 2px 5px",
    },
    FormField: {
        flex: "0 1 600px",
        flexDirection: "row",
        margin: "2px 5px 2px 5px",
    },
    FormFieldCheckBoxAligned: {
        flex: "0 1 600px",
        margin: "0px 10px 0px 10px",
    },
}));

const Component = React.memo(function Component(props) {
    const {InitalFormValuesFromParent, FieldOptions, HandleFormFieldChange, HandleSubmitForm} = props;
    //eslint-disable-next-line
    const theme = useTheme();
    //eslint-disable-next-line
    const classes = styles({...props, theme});

    /***************** REFS ******************/

    /***************** REFS ******************/

    /***************** CONST ******************/

    /***************** CONST ******************/

    /***************** STATE ******************/
    const [InitialFormValues, setInitialFormValues] = React.useState({}); //INITIAL FORM VALUES
    const [FormValues, setFormValues] = React.useState({}); //FINAL FORM VALUES

    /***************** STATE ******************/

    /***************** CALLBACK ******************/

    /***************** CALLBACK ******************/

    /***************** EFFECTS ******************/
    useEffect(() => {
        if (InitalFormValuesFromParent) {
            console.log("InitalFormValuesFromParent", InitalFormValuesFromParent);
            setInitialFormValues(InitalFormValuesFromParent);
            setFormValues(InitalFormValuesFromParent);
        }
    }, [InitalFormValuesFromParent]);
    /***************** EFFECTS ******************/

    /***************** FUNCTIONS ******************/
    const HandleUpdateFormValues = (field, values) => {
        let value = values.Value;

        var UpdateFormValues = {[field]: value};

        setFormValues({...FormValues, ...UpdateFormValues});

        if (InitialFormValues[field] !== value) {
            HandleFormFieldChange(field, value);
        }
    };
    const handleSelectChange = (field, SelectedDetails) => {
        //Hanlding the select change
        //Checking Pristine

        let SelectedValues = SelectedDetails.Value;

        /************* DONT MODIFY THIS LOGIC OR THE PRISTINE AND INVALID WILL BE LOST *****************/

        var UpdatedFormValues = {...FormValues, ...{[field]: SelectedValues}};
        /************* DONT MODIFY THIS LOGIC OR THE PRISTINE AND INVALID WILL BE LOST *****************/

        /************* IF NO CONDITIONAL SELECT USE THIS *****************/

        setFormValues(UpdatedFormValues);
        if (InitialFormValues[field] !== SelectedValues) {
            HandleFormFieldChange(field, SelectedValues);
        }

        /************* IF NO CONDITIONAL SELECT USE THIS *****************/
    };
    /***************** FUNCTIONS ******************/

    /***************** RENDER ******************/
    let FormDetailsComponent;
    if (FormValues) {
        FormDetailsComponent = (
            <React.Fragment>
                <div className={classes.FormMultilineFlex} style={{justifyContent: "flex-start"}}>
                    <div className={classes.FormField} style={{flex: "0 0 390px"}}>
                        <FormCompontent
                            Name="VerticalSpaceContactSummaryTable"
                            InitialValue={InitialFormValues.VerticalSpaceContactSummaryTable ? InitialFormValues.VerticalSpaceContactSummaryTable : null}
                            FormValue={FormValues.VerticalSpaceContactSummaryTable ? FormValues.VerticalSpaceContactSummaryTable : null}
                            OutputValue={(values) => HandleUpdateFormValues("VerticalSpaceContactSummaryTable", values)}
                            Component="Input"
                            Variant="Outlined"
                            Label="Vertical Space Table Contact / Summary "
                            NoMessage={false}
                            // LegendOffsetHeight="0"
                            // LegendOffsetWidth="0"
                            LabelMaxWidth="280px"
                            FieldMaxWidth="100px"
                            LabelAlign="Left"
                            // Required={false}
                            ReadOnly={false}
                        />
                    </div>
                    <div style={{fontSize: "0.8rem"}}>mm</div>
                </div>
                <div className={classes.FormMultilineFlex} style={{justifyContent: "flex-start"}}>
                    <div className={classes.FormField} style={{flex: "0 0 390px"}}>
                        <FormCompontent
                            Name="VerticalSpaceSummaryDetailTable"
                            InitialValue={InitialFormValues.VerticalSpaceSummaryDetailTable ? InitialFormValues.VerticalSpaceSummaryDetailTable : null}
                            FormValue={FormValues.VerticalSpaceSummaryDetailTable ? FormValues.VerticalSpaceSummaryDetailTable : null}
                            OutputValue={(values) => HandleUpdateFormValues("VerticalSpaceSummaryDetailTable", values)}
                            Component="Input"
                            Variant="Outlined"
                            Label="Vertical Space Table Summary / Detail "
                            NoMessage={false}
                            // LegendOffsetHeight="0"
                            // LegendOffsetWidth="0"
                            LabelMaxWidth="280px"
                            FieldMaxWidth="100px"
                            LabelAlign="Left"
                            // Required={false}
                            ReadOnly={false}
                        />
                    </div>
                    <div style={{fontSize: "0.8rem"}}>mm</div>
                </div>
                <div className={classes.FormMultilineFlex} style={{justifyContent: "flex-start"}}>
                    <div className={classes.FormField} style={{flex: "0 0 390px"}}>
                        <FormCompontent
                            Name="VerticalSpaceDetailSummaryTable"
                            InitialValue={InitialFormValues.VerticalSpaceDetailSummaryTable ? InitialFormValues.VerticalSpaceDetailSummaryTable : null}
                            FormValue={FormValues.VerticalSpaceDetailSummaryTable ? FormValues.VerticalSpaceDetailSummaryTable : null}
                            OutputValue={(values) => HandleUpdateFormValues("VerticalSpaceDetailSummaryTable", values)}
                            Component="Input"
                            Variant="Outlined"
                            Label="Vertical Space Table Details / Total "
                            NoMessage={false}
                            // LegendOffsetHeight="0"
                            // LegendOffsetWidth="0"
                            LabelMaxWidth="280px"
                            FieldMaxWidth="100px"
                            LabelAlign="Left"
                            // Required={false}
                            ReadOnly={false}
                        />
                    </div>
                    <div style={{fontSize: "0.8rem"}}>mm</div>
                </div>
                <div className={classes.FormMultilineFlex}>
                    <div className={classes.FormField} style={{flex: "0 0 872px", height: "25px", display: "flex", alignItems: "center"}}>
                        <CheckBox
                            Inputname="WithReferenceCol"
                            label="With Reference Column"
                            initialvalue={InitialFormValues.WithReferenceCol === true ? true : false}
                            curvalue={FormValues.WithReferenceCol}
                            ShareInputValue={(value) => HandleUpdateFormValues("WithReferenceCol", value)}
                            LabelMaxWidth="270px"
                        />
                    </div>
                </div>
                <div className={classes.FormMultilineFlex}>
                    <div className={classes.FormField} style={{flex: "0 0 872px", height: "25px", display: "flex", alignItems: "center"}}>
                        <CheckBox
                            Inputname="WithVATColumn"
                            label="With VAT Column"
                            initialvalue={InitialFormValues.WithVATColumn === true ? true : false}
                            curvalue={FormValues.WithVATColumn}
                            ShareInputValue={(value) => HandleUpdateFormValues("WithVATColumn", value)}
                            LabelMaxWidth="270px"
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }
    return <TabNavContent ClassExtendTabContent={classes.ClassExtendTabContent}>{FormDetailsComponent}</TabNavContent>;

    /***************** RENDER ******************/
});

export default Component;
